import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { EnNavHeader } from './EnNavHeader';
import { EnNavFooter } from './EnNavFooter';
import EnUserMenu from './EnUserMenu';

import { getClientId } from './utils/analyticsclientIdUtils';
import { encryptData } from './utils/encryptionUtils';
import { API_URL } from './utils/constants'

class EnUserCardRemoveClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: null, // Initialize userData state to null
            parentState: this.props.location.state,
            canSubmitState: true,
            canSubmitMsg: '',
            actionSuccess: false
        };
    }

    componentDidMount() {
        // Retrieve data from session storage
        const userDataFromStorage = sessionStorage.getItem('userData');

        // Parse the data if it exists and set it to the component state
        if (userDataFromStorage) {
            this.setState({ userData: JSON.parse(userDataFromStorage) });
        }

        {
            // Google analytic
            const documentPath = "Card Remove"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
        window.scrollTo(0, 0);
    }

    async callApiCardInfoUpdate(loyaltyMemberId, cardNumber, cardStatus, cardNickName, defaultCard, refLang) {
        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        const payload = { LoyaltyMemberId: loyaltyMemberId, CardNumber: cardNumber, CardStatus: cardStatus, CardNickName: cardNickName, DefaultCard: defaultCard, RefLang: refLang, Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        const token = this.state.userData.token;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            // Add the wait cursor class to the body element
            document.body.classList.add('wait-cursor');

            const response = await fetch(`${API_URL}/api/CrmCardUpdate`, requestOptions);
            const data = await response.json();
            if (data && data.responseCode === 'OK') {
                this.setState({
                    canSubmitState: false,
                    canSubmitMsg: 'Card remove success.',
                    actionSuccess: true
                });
            }
            else {
                //some error here
                this.setState({
                    canSubmitState: true,
                    canSubmitMsg: data.statusMsg,
                    actionSuccess: false
                });
            }
        } catch (error) {
            console.error('API call error:', error);
        }
        finally {
            document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        }
    }

    handleCardUpdateInfo(cardNumber) {
        this.callApiCardInfoUpdate(this.state.userData.loyaltyMemberId, cardNumber, "1", "", false, "en");
    }

    render() {
        const { userData, parentState, canSubmitState, canSubmitMsg, actionSuccess } = this.state;
        const selectedCard = parentState.selectedCard;
        const selectedCardFromlist = parentState.selectedCardFromlist;

        let selectedCardNumber, selectedcardBalance, selectedCardStatus, selectedcardImg;
        if (selectedCard) {
            selectedcardBalance = selectedCard.cardBalance;
        }
        if (selectedCardFromlist) {
            selectedCardNumber = selectedCardFromlist.cardNumber;
            selectedCardStatus = selectedCardFromlist.cardStatusText;
            selectedcardImg = selectedCardFromlist.cardImg;
        }

        return (
            <>
                <EnNavHeader />

                {/* Render the user data */}
                {userData && parentState && (
                    <main id="main">
                        <section id="profile_section" className="profileBanner keyboardFocus" aria-label="Profile" tabIndex={-1}>
                            <EnUserMenu />
                        </section>
                        <section className="section-dashboard overflow-hidden pb-5">
                            <div className="container mt-4">
                                <div className="row mb-5 px-2">
                                    <div className="col-md-12">
                                        <h2 className="h4 fw-semibold my-4">Remove Card</h2>
                                        <form className="form-sr">
                                            <div className="row mb-4 g-3 align-items-start">
                                                <div className="col-md-4">
                                                    <img src={`media/rewards/cards/${selectedcardImg}`} alt={selectedCardNumber} className="img-fluid" />
                                                </div>
                                                {actionSuccess ? (
                                                    <>
                                                        <div className="col-md-6 ps-4">
                                                            <h4 className="h5 fw-semibold mb-3"><span className="text-green-1 fw-semibold">Card remove success.</span></h4>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                            <div className="col-md-6 ps-4">
                                                                <h4 className="h5 fw-semibold">({selectedCardNumber})</h4>
                                                                <h4 className="h5 fw-semibold mb-3"><span className="text-green-1 fw-semibold">฿ {selectedcardBalance}</span></h4>
                                                                <p className="fw-semibold">Status : <span>{selectedCardStatus}</span></p>
                                                                <div className="row">
                                                                    <div className="col">
                                                                        {canSubmitState ? (
                                                                            <button type="button" className="btn btn-primary btn-slim rounded-pill" onClick={() => this.handleCardUpdateInfo(selectedCardNumber)}>
                                                                                Submit
                                                                            </button>
                                                                        ) : (
                                                                            <span>{canSubmitMsg}</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </>
                                                )}                                                
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>

                )}

                <EnNavFooter />
            </>
        );
    }
}

export const EnUserCardRemove = withRouter(EnUserCardRemoveClass);